<div
  (click)="!isAvailable() ? null : addToCart()"
  [style.background-color]="(cardColor() | contentBuilderColor) || '#ffffff'"
  class="h-full space-y-2"
>
  <div class="relative w-full">
    @if (product().description?.length || product().allergens?.length) {
      <i
        (click)="!isAvailable() ? null : showProductModal(); $event?.stopPropagation?.()"
        class="icon icon-c-info-3 pointer-events-auto absolute right-2 top-0 z-10 content-center pb-3 pl-3 text-center text-2xl font-semibold"
        [style.color]="textColor() | contentBuilderColor"
        [class.opacity-50]="!isAvailable()"
      ></i>
    }
    <p
      class="break-words font-accent text-2xl font-bold xl:text-md"
      [style.color]="textColor() | contentBuilderColor"
    >
      {{ product()[ProductKeys.Name] }}
    </p>
  </div>
  <div class="relative flex w-full flex-row gap-2">
    <div class="flex h-full w-full flex-col justify-between">
      <p
        class="line-clamp-4 text-justify font-base text-base"
        [style.color]="textColor() | contentBuilderColor"
      >
        {{ product()[ProductKeys.Description] }}
      </p>
      <div class="self-end">
        <div
          *ngIf="!product()[ProductKeys.PriceToDisplay]"
          class="mt-2 flex flex-row gap-2 text-base xl:mt-3 xl:text-md"
          [style.color]="textColor() | contentBuilderColor"
        >
          <ng-container *ngIf="displayDiscount(); else priceOnly">
            <app-price-atom
              class="mr-1"
              [amount]="product()[ProductKeys.Discount] ?? 0"
              [bold]="true"
            ></app-price-atom>
            <app-tag-atom
              class="mr-1"
              color="success"
              text="-{{ discountPercentage() }}%"
              *ngIf="product()[ProductKeys.Price]"
            ></app-tag-atom>
            <app-price-atom
              class="mr-1"
              [amount]="product()[ProductKeys.Price]"
              [discount]="true"
              [bold]="true"
              *ngIf="product()[ProductKeys.Price]"
            ></app-price-atom>
          </ng-container>
          <ng-template #priceOnly>
            <app-price-atom
              class="mr-1"
              [amount]="product()[ProductKeys.Price]"
              [bold]="true"
            ></app-price-atom>
          </ng-template>
        </div>
        <div
          *ngIf="product()[ProductKeys.PriceToDisplay]"
          class="mt-2 text-base xl:mt-3 xl:text-md"
        >
          <span class="mr-1"> {{ product()[ProductKeys.PriceToDisplay] }}</span>
        </div>
      </div>
    </div>
    <div
      class="push-image relative w-36 overflow-hidden rounded-lg object-cover"
      [class.h-36]="!product().images?.thumbnail?.url"
      [style.backgroundColor]="cardColor() | contentBuilderColor"
    >
      <div
        class="absolute inset-0 h-24 w-full rounded-lg"
        [appRadialGradient]="product()[ProductKeys.Images]?.thumbnail?.colors"
      ></div>
      <img
        *ngIf="product().images?.thumbnail?.url"
        class="push-image relative z-10 w-28 object-cover"
        [src]="product().images?.thumbnail?.url"
        alt="image"
      />
      <!-- Unavailable Overlay -->
      <div
        *ngIf="!isAvailable()"
        class="absolute inset-0 z-20 flex h-[99px] items-center justify-center bg-black bg-opacity-50"
      >
        <span class="text-sm font-bold text-white">{{ 'UNAVAILABLE' | translate }}</span>
      </div>
    </div>
  </div>
</div>
